module.exports = __webpack_public_path__ + "static/media/patent_pending_white.cb880306.svg";